import { SVG, SVGProps } from './svg'

export function IconSearch(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M16.9 15.5l4 4c.2.2.1.5 0 .7l-.7.7a.5.5 0 01-.8 0l-4-4c0-.2-.2-.3-.3-.4l-.7-1a7 7 0 01-11.2-4 7 7 0 1112.2 3l1 .6.5.4zM5 10a5 5 0 1010 0 5 5 0 00-10 0z" />
    </SVG>
  )
}
